import { Box } from "@chakra-ui/react";
import { VendeAIDataProps } from "utils/active-vende-ai";

export function AbaDashboardVendeAI({
  vendeAiData,
}: {
  vendeAiData: Partial<VendeAIDataProps>;
}) {
  const url = vendeAiData.detailsDashboardLink;

  return (
    <Box>
      <Box
        as="iframe"
        src={url} // <-- AQUI! O atributo correto é 'src'
        title="Painel de Relatórios do Looker Studio" // <-- Boa prática para acessibilidade
        width="100%" // <-- Usando 'width' e 'height' como props para o iframe
        height="calc(100vh - 135px)" // <-- Exemplo para ocupar a altura total da viewport
        border="0" // Remove a borda padrão do iframe
        allowFullScreen // Permite modo tela cheia
        // Atributos adicionais para compatibilidade cross-browser com tela cheia
        //   mozAllowFullScreen
        // webkitAllowFullScreen
      />
    </Box>
  );
}
